import axios from 'axios';

export const getAxios = async (inputData) => {
  return await axios.get(inputData.url)
}

export const nonAuthPostAxios = async (inputData) => {
  return await axios.post(inputData.url, inputData.data)
}